import { render, staticRenderFns } from "./verifyresult.vue?vue&type=template&id=129de214&"
import script from "./verifyresult.vue?vue&type=script&lang=js&"
export * from "./verifyresult.vue?vue&type=script&lang=js&"
import style0 from "./verifyresult.vue?vue&type=style&index=0&id=129de214&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports